// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `img {
  max-height: 40em;
  max-width: 50em;
}

.file-container {
  min-height: 20em;
}

.modal-body .first-modal {
  padding: 0;
  min-height: 600px !important;
}

::ng-deep .modal-dialog.modal-lg {
  max-width: 1200px !important;
  width: 1200px !important;
}

::ng-deep .file-name {
  text-align: center;
}

::ng-deep .dialog-crop-container.mat-dialog-content {
  margin: 0 auto;
}

::ng-deep modal-container.modal.fade.show {
  /* position: absolute; */
  top: -5px;
}

::ng-deep .image-dimensions {
  margin: 13px;
}

.modal-title {
  font-weight: 500;
  font-size: 1.3rem;
  color: #48465b;
}

.modal-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 0 0 1.25rem 0;
  border-bottom: 1px solid #ebedf2;
  border-top-left-radius: calc(0.3rem - 1px);
  border-top-right-radius: calc(0.3rem - 1px);
  margin-bottom: 1.25rem;
}

.justified-btn {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
}`, "",{"version":3,"sources":["webpack://./src/app/views/media-manager/view-file/view-file.component.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;EAC5B,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,wBAAwB;EACxB,SAAS;AACX;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EAGE,aAAa;EAGb,uBAAuB;EAGvB,8BAA8B;EAC9B,sBAAsB;EACtB,gCAAgC;EAChC,0CAA0C;EAC1C,2CAA2C;EAC3C,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;AAChC","sourcesContent":["img {\r\n  max-height: 40em;\r\n  max-width: 50em;\r\n}\r\n\r\n.file-container {\r\n  min-height: 20em;\r\n}\r\n\r\n.modal-body .first-modal {\r\n  padding: 0;\r\n  min-height: 600px !important;\r\n}\r\n\r\n::ng-deep .modal-dialog.modal-lg {\r\n  max-width: 1200px !important;\r\n  width: 1200px !important;\r\n}\r\n\r\n::ng-deep .file-name {\r\n  text-align: center;\r\n}\r\n\r\n::ng-deep .dialog-crop-container.mat-dialog-content {\r\n  margin: 0 auto;\r\n}\r\n\r\n::ng-deep modal-container.modal.fade.show {\r\n  /* position: absolute; */\r\n  top: -5px;\r\n}\r\n\r\n::ng-deep .image-dimensions {\r\n  margin: 13px;\r\n}\r\n\r\n.modal-title {\r\n  font-weight: 500;\r\n  font-size: 1.3rem;\r\n  color: #48465b;\r\n}\r\n\r\n.modal-header {\r\n  display: -webkit-box;\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  -webkit-box-align: start;\r\n  -ms-flex-align: start;\r\n  align-items: flex-start;\r\n  -webkit-box-pack: justify;\r\n  -ms-flex-pack: justify;\r\n  justify-content: space-between;\r\n  padding: 0 0 1.25rem 0;\r\n  border-bottom: 1px solid #ebedf2;\r\n  border-top-left-radius: calc(0.3rem - 1px);\r\n  border-top-right-radius: calc(0.3rem - 1px);\r\n  margin-bottom: 1.25rem;\r\n}\r\n\r\n.justified-btn {\r\n  display: flex;\r\n  align-items: flex-start;\r\n  justify-content: space-between;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
